import React from "react";
import { Checkbox } from "component-library";
import { dataTestIds } from "data-testids";

import "./SelectAllControl.scss";

interface IItems {
  id: string;
}

export interface ISelectAllControlTexts {
  markAsReadAlertsLabel: string;
  markAsUnreadAlertsLabel: string;
  selectAllAlertsLabel: string;
}

export interface ISelectAllControlProps {
  texts: ISelectAllControlTexts;
  selectedItems: string[];
  markItemsAsRead: (selectedItems: string[]) => void;
  markItemsAsUnread: (selectedItems: string[]) => void;
  deselectItems: (selectedItems: string[]) => void;
  selectItems: (selectedItems: string[]) => void;
  items: IItems[];
  onSelectAllClick?: () => void;
}

const SelectAllControl: React.FC<
  React.PropsWithChildren<ISelectAllControlProps>
> = (props) => {
  const { texts, selectedItems } = props;
  const markItemsAsRead = () => {
    if (selectedItems.length > 0) {
      props.markItemsAsRead(selectedItems);
    }
  };

  const markItemsAsUnread = () => {
    if (selectedItems.length > 0) {
      props.markItemsAsUnread(selectedItems);
    }
  };

  const handleSelectAllChange = () => {
    const items = props.items.map((item) => item.id);
    const isAllSelected = !items.some(
      (item) => !props.selectedItems.includes(item)
    );

    if (isAllSelected) {
      props.deselectItems(items);
    } else {
      props.selectItems(
        items.filter((item) => !props.selectedItems.includes(item))
      );
      props.onSelectAllClick?.();
    }
  };

  return (
    <div className="c-select-all-control">
      <Checkbox
        htmlId="selectAll"
        name="selectAll"
        checked={
          Boolean(props.items.length) &&
          props.items.every((item) => selectedItems.includes(item.id))
        }
        value="selectAll"
        ariaLabel="selectAll"
        onChange={handleSelectAllChange}
        label={texts.selectAllAlertsLabel}
      />
      <div className="c-select-all-control__button-set">
        <a
          className="g-alternative-link g-alternative-link--lg c-select-all-control__mark-as-read"
          onClick={markItemsAsRead}
          tabIndex={0}
          data-testid={
            dataTestIds.nuJobsApp["Components.SelectAllControls.markAsRead"]
          }
        >
          {texts.markAsReadAlertsLabel}
        </a>
        <a
          className="g-alternative-link g-alternative-link--lg c-select-all-control__mark-as-unread"
          onClick={markItemsAsUnread}
          tabIndex={0}
          data-testid={
            dataTestIds.nuJobsApp["Components.SelectAllControls.markAsUnread"]
          }
        >
          {texts.markAsUnreadAlertsLabel}
        </a>
      </div>
    </div>
  );
};

export default SelectAllControl;
